import React from 'react';
import { useStore } from '../state/store';
import { Card, Chip, TermHelp } from './ui';
import { describeRunway } from '../lib/derive';
import { d001Surfacing } from '../lib/operatingMode';

/** Light commercial pulse — one progression + decision-relevant runway. */
export function CommercialPulse({ go }) {
  const { d } = useStore();
  const { funnel, runway, sprint } = d;
  const c = funnel.counts || {};
  const runwayCopy = describeRunway(runway);
  const runwayTone = { healthy: 'green', watch: 'amber', critical: 'red', unknown: '' }[runway.status];
  const surfacing = d001Surfacing(d);
  const researched = c.universe ?? 0;
  const priority = c.tierA ?? 0;
  const contacted = c.contacted ?? 0;
  const responses = c.engaged ?? 0;
  const conversations = c.discovery ?? 0;
  const opportunities = c.qualified ?? 0;
  const progression = [
    `${researched} researched`,
    `${priority} priority`,
    `${contacted} contacted`,
    `${responses} responses`,
    `${conversations} conversations`,
    `${opportunities} opportunities`,
  ].join(' → ');

  return (
    <section className="section">
      <Card title="Commercial Pulse" sub="Derived from recorded state — Unknown stays Unknown.">
        <div className="bridge-copy" style={{ marginBottom: 12, lineHeight: 1.5 }}>
          {progression}
        </div>

        <div className="grid g2" style={{ gap: 12 }}>
          <div className="stat">
            <span className="label">Next gate</span>
            <span className="value sm">{sprint.nextGate?.label || '—'}</span>
          </div>
          <div className="stat">
            <span className="label">
              <span>Runway</span>
              <TermHelp term="currentRunway" label="Runway" />
            </span>
            <span className="value sm"><Chip tone={runwayTone}>{runwayCopy.primary}</Chip></span>
            <span className="foot">
              {runway.months == null ? (runwayCopy.secondary || 'Unknown') : 'At current spending'}
            </span>
          </div>
        </div>

        {surfacing.showOnToday && funnel.primary && (
          <>
            <div className="hr" />
            <div className="row" style={{ alignItems: 'center', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div className="eyebrow">
                  Primary D001
                  <TermHelp term="primaryD001" label="Primary D001" />
                </div>
                <strong>{funnel.primary.accountName || funnel.primary.name || 'Primary deal'}</strong>
                <div className="dim tiny">{d.d001?.constraint?.blocker || funnel.primary.stage}</div>
              </div>
              <button type="button" className="btn sm primary" onClick={() => go('primary-deal')}>
                Open deal workspace
              </button>
            </div>
          </>
        )}
        {surfacing.level === 'candidate' && !surfacing.showOnToday && (
          <p className="dim tiny" style={{ marginTop: 10 }}>
            D001 candidate(s) live in Pipeline — not yet Primary.
            <button type="button" className="btn ghost sm" style={{ marginLeft: 8 }} onClick={() => go('pipeline')}>
              Open Pipeline
            </button>
          </p>
        )}
      </Card>
    </section>
  );
}
